export default __webpack_public_path__ + "static/media/youtube-icon.84d90693.svg";